module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', [_c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('i', [_vm._v("For Bonnie")]), _c('br'), _c('i', [_vm._v("and for our children")]), _vm._v(","), _c('br'), _c('i', [_vm._v("Will and Emily")])]), _vm._v(" "), _c('p', {
    staticClass: "pagebreak"
  }), _vm._v(" "), _c('p', [_c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('i', [_vm._v("The mass and majesty of this world, all")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("That carries weight and always weighs the same")])]), _vm._v(" "), _c('p', [_c('i', [_vm._v("Lay in the hands of others; they were small")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("And could not hope for help, and no help came")]), _c('br'), _c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', [_c('i', [_vm._v("W. H. Auden")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-771f681d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/04ded.vue
// module id = 66
// module chunks = 0